import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Sidebar } from "../../components/admin/Sidebar";
import { Header } from "../../components/admin/Header";
import { cn } from "../../lib/utils";
import { Dashboard } from "../../page/admin/Dashboard";
import { CreateEvent } from "../../page/admin/CreateEvent";
import { Orders } from "../../page/admin/Orders";
import { GuestUsers } from "../../page/admin/GuestUsers";
import { Users } from "../../page/admin/Users";
import NotFound from "../../page/admin/Notfound";
import EventDetails from "../../page/admin/EventDetails";
import Scanner from "../../page/admin/Scanner";
import AllOrders from "../../page/admin/AllOrders";
import { EmailTemplateManager } from "../../page/admin/EmailTemplate";
import Coupon from "../../page/admin/Coupon";

export function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
useEffect(()=>{
console.log(import.meta.env)
},[])
  return (
    <div className="relative flex min-h-screen bg-gradient-to-br from-[#FFF4F0] to-white">
      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        collapsed={sidebarCollapsed}
        onOpenChange={setSidebarOpen}
        onCollapsedChange={setSidebarCollapsed}
      />

      {/* Main Content Area */}
      <div
        className={cn(
          "flex flex-1 flex-col transition-all duration-300 ease-in-out",
          sidebarCollapsed ? "lg:pl-16" : "lg:pl-64"
        )}
      >
        {/* Header */}
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          sidebarCollapsed={sidebarCollapsed}
          onCollapsedChange={setSidebarCollapsed}
        />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto">
          <div className="container mx-auto px-0 md:px-2 py-0 md:py-3 sm:px-6 lg:px-8">
            <Routes>
              <Route index element={<Dashboard />} />
              <Route path="events" element={<CreateEvent />} />
              <Route path="orders/:eventId" element={<Orders />} />
              <Route path="orders" element={<AllOrders />} />
              {/* <Route path="guestusers" element={<GuestUsers />} /> */}
              <Route path="users" element={<Users />} />
              <Route path="event-details/:id" element={<EventDetails />} />
              <Route path="event/:eventId/orders" element={<Orders/>}/>
              <Route path="scan" element={<Scanner/>}/>
              <Route path="email-templates" element={<EmailTemplateManager />} />
              <Route path="coupon" element={<Coupon />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </main>

        {/* Footer */}
        {/* <footer className="border-t border-[#F4A696]/20 bg-white px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <div className="text-center text-sm text-[#1B3C5C]/60 sm:text-left">
              © 2026 EventHouse. All rights reserved.
            </div>
            <div className="flex gap-4 text-sm">
              <a href="#" className="text-[#F4A696] hover:text-[#E89580] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-[#F4A696] hover:text-[#E89580] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </footer> */}
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-[#1B3C5C]/50 backdrop-blur-sm lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
}
